import React, { useCallback } from 'react';
import { Checkbox } from '@makemydeal/dr-ui-bricks-components';
import type { IncentiveType } from '@makemydeal/dr-shared-bff-types';
import CheckboxOptionGroup from '../common/CheckboxOptionGroup/CheckboxOptionGroup';
import { IncentivesSectionContainer, SectionQuestion } from './IncentivesSection.styles';
import { INCENTIVE_LABELS, INCENTIVE_TYPES } from '../../constants';
import type { IncentivesSectionProps } from '../../types';

const IncentivesSection: React.FC<IncentivesSectionProps> = ({ selectedIncentives, onToggle }) => {
    const handleCheckboxChange = useCallback(
        (incentive: IncentiveType) => (e: React.ChangeEvent<HTMLInputElement>) => {
            const newSelected = new Set(selectedIncentives);
            if (e.target.checked) {
                newSelected.add(incentive);
            } else {
                newSelected.delete(incentive);
            }
            onToggle(Array.from(newSelected));
        },
        [selectedIncentives, onToggle]
    );

    return (
        <IncentivesSectionContainer>
            <SectionQuestion size="large" weight="bold">
                Do you qualify for any special savings incentives?
            </SectionQuestion>
            <CheckboxOptionGroup aria-label="Incentives" data-testid="incentives-group">
                {INCENTIVE_TYPES.map((incentive) => (
                    <Checkbox
                        key={incentive}
                        label={INCENTIVE_LABELS[incentive]}
                        checked={selectedIncentives.includes(incentive)}
                        onChange={handleCheckboxChange(incentive)}
                        name={`incentive-${incentive}`}
                        data-testid={`incentive-${incentive}`}
                    />
                ))}
            </CheckboxOptionGroup>
        </IncentivesSectionContainer>
    );
};

export default IncentivesSection;
